// extracted by mini-css-extract-plugin
export var badge = "SemBadge-module--badge--f5bff";